import React from "react"
import { ErrorMessage } from "formik"
import RuntimeCheck from "./RuntimeCheck"
import VisibilityIcon from "@mui/icons-material/Visibility"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import GlobalInput from "./Global/GlobalInput"

export default function FormikInput({
    label,
    type,
    name,
    onChange,
    setFieldValue,
    isTyping,
    availablity,
    disabled = false,
    value,
    error,
    isRuntimeCheck = false,
    isEyeShow = false,
    className = false,
    messageRuntimeCheck,
    required = true,
    placeholder,
    onPaste
}: any) {
    const [showPassword, setShowPassword] = React.useState<boolean>(false)
    const togglePasswordVisibility = (): void => setShowPassword(!showPassword)

    return (
        <div className="w-full">
            <div className={`flex flex-col gap-1 relative`}>
                <>
                    <GlobalInput
                        label={label}
                        name={name}
                        type={showPassword ? "text" : type}
                        placeholder={placeholder}
                        onChange={onChange}
                        disabled={disabled}
                        isError={error ? true : false}
                        value={value}
                        onPaste={onPaste}
                    />
                    {/* <Field
                        type={showPassword ? "text" : type}
                        disabled={disabled}
                        name={name}
                        className={
                            className
                                ? className
                                : `w-full text-[0.65rem] sm:text-xs lg:text-sm xl:text-base  outline-none border-1 border-inputborder px-3.5 py-2 bg-[#F8F8F8] text-input ring-gray-300 placeholder:text-gray-400 sm:leading-6 rounded-sm`
                        }
                        onChange={onChange}
                        value={value}
                    /> */}
                    {isRuntimeCheck && (
                        <RuntimeCheck
                            isTyping={isTyping}
                            availablity={availablity}
                            onClick={() => {
                                setFieldValue(name, "")
                            }}
                            value={value}
                            error={error}
                            message={messageRuntimeCheck}
                            className={`top-2 -right-2 ${className}`}
                        />
                    )}
                    {isEyeShow && (
                        <div
                            onClick={togglePasswordVisibility}
                            className="absolute top-2 -right-2 flex items-center px-4 text-gray-600 cursor-pointer"
                        >
                            {showPassword ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </div>
                    )}

                    {error && (
                        <div className="text-red-500 text-xs">
                            {error}
                        </div>
                    )}
                    {/* <ErrorMessage
                        name={'password'}
                        component="div"
                        className="text-red-500 text-xs"
                    /> */}
                </>
            </div>
        </div>
    )
}
